import { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  subtitle?: string;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const Card = ({ title, subtitle, action, children, className }: CardProps) => {
  return (
    <div className={`card ${className ? className : ""}`}>
      {title ? (
        <div className="cardTitle">
          <span>{title}</span>
          {subtitle ? <span className="cardSubtitle">{subtitle}</span> : null}
          {action}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Card;
